<template>
  <!-- 订单列表 -->
  <div class="focusOrder">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['订单管理', $route.meta.title]"
    >
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">单据状态：</label>
        <el-select
          placeholder="单据状态"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.status"
        >
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          v-model="searchForm.start"
          style="width: 200px; margin-right: 5px"
          placeholder="选择开始日期"
        >
        </el-date-picker>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          v-model="searchForm.end"
          style="width: 200px; margin-right: 5px"
          placeholder="选择结束日期"
        >
        </el-date-picker>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入订单号"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="seach"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="entName"
        align="center"
        show-overflow-tooltip
        label="机构名称"
      >
      </el-table-column>
      <el-table-column
        prop="businessName"
        align="center"
        show-overflow-tooltip
        label="企业名称"
      >
      </el-table-column>
      <el-table-column
        prop="id"
        label="订单编号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="price"
        label="订单金额"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="payPrice"
        label="已支付金额"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="noPrice"
        label="未支付金额"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="订单状态"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="time"
        label="下单时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "focusOrder",
  data() {
    return {
      /**表格数据 */
      //序号	机构	单据编号	客户编号	客户名称	收货人
      // {
      //   entId:"机构",
      //   entName:"机构名称",
      //   id:"订单编号",
      //   price:"订单金额",
      //   payPrice:"已支付金额",
      //   noPrice:"未支付金额",
      //   status:"订单状态",
      //   time:"下单时间",
      // }
      tableData: [],
      /**搜索表单 */
      searchForm: {
        status: "99",
        start: this.$formatDate(new Date().getTime() - 2592000000),
        end: this.$formatDate(new Date()),
        name: "",
      },
      statusList: [
        { value: "99", label: "全部" },
        { value: "1", label: "未支付" },
        { value: "2", label: "未完成" },
        { value: "3", label: "待收货" },
        { value: "5", label: "已完成" },
        { value: "0", label: "已取消" },
      ],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    seach() {
      this.getTableData(1);
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      if (!this.searchForm.start) {
        this.$message({
          message: "请输入开始时间",
          type: "warning",
        });
        return;
      }
      if (!this.searchForm.end) {
        this.$message({
          message: "请输入结束时间",
          type: "warning",
        });
        return;
      }
      let data = {
        userId: localStorage.getItem("userId"),
        entId: localStorage.getItem("entId"),
        status: this.searchForm.status,
        sqlValue: this.searchForm.name,
        startTime: this.searchForm.start,
        endTime: this.searchForm.end,
        pageIndex: this.currPage,
        pageSize: this.pageSize,
        orderType: "FJC",
      };
      this.$request({
        method: "post",
        url: "Order/GetHtSpellGroupOrder",
        data: data,
      })
        .then((res) => {
          console.log(res);
          this.tableData = [];
          if (res.success) {
            this.allPage = res.toTal;
            this.tableData = res.list.map((item) => ({
              entId: item.EntId,
              entName: item.EntName,
              businessName: item.BusinessName,
              id: item.OrderNo,
              price: item.RealAmount,
              payPrice: item.HisPayFree,
              noPrice: item.PayFree,
              status: item.Status,
              time: item.Addtime,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    addDetail(row) {
      this.$router.push({
        path: "orderListDetail",
        query: {
          row: row,
        },
      });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
  },
};
</script>

<style scoped>
.focusOrder {
  width: 100%;
  height: 100%;
}
</style>
